<div class="mask-container">
  <div class="mask" [style]="style"></div>
</div>
